angular.module('aprima-legacy-common').factory('AprimaRestangular',
    [
        '$log',
        '$state',
        '_',
        'AppRoutes',
        'AprimaAnalytics',
        'Bridge',
        'BrowserService',
        'configuration',
        'debugLogService',
        'LocalStorageRepository',
        'Restangular',
        'TransitionManager',
        function(
            $log,
            $state,
            _,
            AppRoutes,
            AprimaAnalytics,
            Bridge,
            BrowserService,
            configuration,
            debugLogService,
            LocalStorageRepository,
            Restangular,
            TransitionManager
        ) {

            'use strict';

            var alwaysIgnoreCache = false;
            var debugModeValue = LocalStorageRepository.getSupportedFeatures();

            //to ignore the cache, you can call this like .get({ignoreCache: true}); or .get('baseurl', {ignoreCache: true});
            var get = function(endpointBase, options) {
                if (!_.isString(endpointBase) && !options) {
                    options = endpointBase;
                    endpointBase = null;
                }

                options = _.defaults(options || {}, {
                    ignoreCache: BrowserService.isLegacyIE(),
                    debugMode: false
                });

                var restangular = Restangular.withConfig(function(RestangularConfigurer) {

                    var clientUrl = LocalStorageRepository.getClientURL();
                    if (!clientUrl) {
                        throw new Error('Cannot send request (configuration error): empty ClientURL');
                    }

                    var urlComponents = [
                        clientUrl.replace(/\/$/, ''),
                        'api',
                        endpointBase ? endpointBase : '',
                        configuration.SERVER_API_VERSION
                    ];

                    var baseUrl = _.filter(urlComponents, function(c) {
                        return !_.isNull(c) && !_.isEmpty(c);
                    }).join('/');

                    RestangularConfigurer.setBaseUrl(baseUrl);

                    var headers = {
                        'Auth-Token': LocalStorageRepository.getJsonWebToken(),
                        'ApiKey': configuration.API_KEY
                    };

                    if (options.ignoreCache) {
                        Bridge.fireEvent('clear-cache', {});

                        headers['Cache-Control'] = 'no-cache, no-store, must-revalidate';
                        headers.Pragma = 'no-cache';
                        headers.Expires = new Date();
                    }

                    RestangularConfigurer.setDefaultHeaders(headers);

                    var isFeatureSupported = function(features) {

                        if (!angular.isArray(features)) {
                            features = [features];
                        }

                        var supportedFeatures = debugModeValue;

                        var matchedValues = _.intersection(features, supportedFeatures);

                        return matchedValues.length === features.length;
                    };

                    var debugModeFeature = isFeatureSupported('DebuggerFeature');

                    if (debugModeFeature) {

                        RestangularConfigurer.addFullRequestInterceptor(function(element, operation, what, url, _5, parameters) {
                            if (alwaysIgnoreCache && operation.toLowerCase() === 'get', 'put', 'post', 'delete') {
                                if (debugLogService.getDebugMode()) {
                                    return {
                                        params: _.assignIn(parameters, {
                                            t: new Date().toJSON(),
                                            debug: true,    //passing debug parameters
                                            levels: 'info,debug,fatal,warn,error'
                                        })

                                    };
                                }
                            }
                            return element;
                        });

                        //displaying information from the response headers if debugMode is true and status=200
                        RestangularConfigurer.addResponseInterceptor(function(data, operation, what, url, response/* ,deferred*/) {
                            if (operation === 'get', 'post', 'put', 'delete') {
                                if (debugLogService.getDebugMode()) {
                                    $log.log('URL:', url);
                                    $log.log('WHAT:', what);
                                    $log.log('THE HEADERS ARE:', JSON.stringify(response.headers(), null, 2));

                                }
                            }
                            return data;
                        });
                    }

                    else {
                        RestangularConfigurer.addFullRequestInterceptor(function(element, operation, what, url, _5, parameters) {
                            if (alwaysIgnoreCache && operation.toLowerCase() === 'get') {
                                return {
                                    params: _.assignIn(parameters, {
                                        t: new Date().toJSON(),

                                    })
                                };
                            }

                            return element;
                        });
                    }

                    RestangularConfigurer.setErrorInterceptor(function(response) {
                        if (response.status === 401) {
                            var deviceId = LocalStorageRepository.getDeviceId();
                            var jwt = LocalStorageRepository.getJsonWebToken();
                            jwt = typeof jwt === 'undefined' ? 'undefined' : jwt ? jwt.length : '"falsy token"';
                            var msg = 'User logged out by 401. Redirected to login. DeviceId=' + deviceId + ' JWT:' + jwt;

                            $log.info(msg);
                            AprimaAnalytics.sendException(msg);


                            if($state.current.alternativeLoginRoute){
                                TransitionManager.transition({ appRoute: AppRoutes.statementslogin.state});
                            }
                            else {
                                TransitionManager.transition({ appRoute: AppRoutes.login.state});
                            }
                        }

                        //displaying the exception information if debugMode is true and status!=200
                        else if (debugModeFeature && response.status !== 200) {
                            if (debugLogService.getDebugMode()) {
                                $log.log('THE EXCEPTION INFORMATION:', JSON.stringify(response.headers(), null, 2));

                            }
                        }

                        if (response.data && response.data.ModelState) {
                            var errorCode = response.data.ModelState['commandResult-ErrorCode'];

                            //errorCode is a string coming from the server. a value of '0' is not falsy.
                            if (errorCode) {
                                response.errorCode = parseInt(errorCode);
                            }
                        }

                        //allows promises to receive these errors
                        return true;
                    });
                });

                return restangular;
            };

            function getUrl(endpointBase, parent){
                var urlComponents = [
                    LocalStorageRepository.getClientURL(),
                    'api',
                    endpointBase ? endpointBase : '',
                    configuration.SERVER_API_VERSION,
                    parent
                ];

                var baseUrl = _.filter(urlComponents, function(c){
                    return !_.isNull(c) && !_.isEmpty(c);
                }).join('/');


                var headers = {
                    'Auth-Token': LocalStorageRepository.getJsonWebToken(),
                    'ApiKey': configuration.API_KEY
                };

                return [baseUrl, headers];
			}

            return {
                get: get,
				getUrl: getUrl,
                disableCaching: function () {
                    alwaysIgnoreCache = true;
                }
            };
        }]);

